
export default function EventBanner() {
  return (
    <section className="py-16 px-6 bg-gray-900">
      <div className="max-w-7xl mx-auto">
        <div className="relative rounded-3xl overflow-hidden shadow-2xl">
          <img 
            src="https://public.readdy.ai/ai/img_res/24d11fdf8a8a178bb4d58a18ee4f170a.jpg" 
            alt="Roseville Farmers Market" 
            className="w-full h-96 object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
          
          <div className="absolute bottom-0 left-0 right-0 p-10">
            <div className="max-w-3xl">
              <p className="text-amber-400 font-semibold text-sm mb-3 uppercase tracking-wide">Every Saturday Year-Round</p>
              <h3 className="text-4xl md:text-5xl font-bold text-white mb-4 leading-tight">
                Roseville Farmers Market
              </h3>
              <p className="text-white/90 text-base mb-6">Vernon Street Town Square • Fresh Local Produce & Artisan Goods</p>
              <button className="bg-white hover:bg-gray-100 text-gray-900 px-8 py-3 rounded-full text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer">
                Learn More
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
